import 'flowbite';
import {
    defineCustomElement as VueDefineCustomElement,
    h,
    createApp,
    getCurrentInstance,
} from 'vue';
// import { defineCustomElement, createApp } from 'vue';
import { createPinia } from 'pinia';
import { addIcons } from 'oh-vue-icons';
import tailwindStyles from './style.css?inline';
import {
    HiCheck,
    HiX,
    HiChevronDown,
    HiChevronDoubleDown,
    HiChevronDoubleUp,
    HiChevronRight,
    HiChevronLeft,
    MdInfo,
} from 'oh-vue-icons/icons';
import { cloneDeep, templateSettings } from 'lodash-es';

import TariffToolMain from './components/TariffToolMain.ce.vue';
import MainDevelop from './components/MainDevelop.vue';
import { createWebComponent } from 'vue-web-component-wrapper';

addIcons(HiCheck, HiChevronDown, HiChevronDoubleDown, HiChevronDoubleUp, HiX, HiChevronRight, HiChevronLeft, MdInfo);

templateSettings.interpolate = /{{([\s\S]+?)}}/g;

function resetStore({ store }) {
    const initialState = cloneDeep(store.$state);
    store.$reset = () => store.$patch(cloneDeep(initialState));
}

export const pluginsWrapper = {
    install(GivenVue) {
        const Vue = GivenVue;

        const pinia = createPinia();
        pinia.use(resetStore);

        Vue.use(pinia);
    },
};

if (process.env.APP_NO_WEBCOMPONENTS?.toLowerCase() === 'true') {
    const debugContainerId = '--debug--living-wage-tariffs-app';
    const app = createApp(MainDevelop);
    pluginsWrapper.install(app);
    app.mount(`#${debugContainerId}`);
} else {
    createWebComponent({
        rootComponent: TariffToolMain,
        elementName: 'living-wage-tariffs',
        plugins: pluginsWrapper,
        cssFrameworkStyles: tailwindStyles,
        VueDefineCustomElement,
        h,
        createApp,
        getCurrentInstance,
    });
}
